// npm run photos -w @eca/web が作るファイルです。手で直さないでください。
export const PHOTOS = {
  "hero-office": {
    "asset": "editorial-accountant",
    "alt": "窓辺の事務所で資料を丁寧に読み込む専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAADQAwCdASoYAA4APu1yrU+pp6QiMAgBMB2JYwC7ACCq8UOo0qX2TgAA/tpLXceV2d0lkke4m6u01gwoV1YYBdEfpsd1NuHTcYjcXGX8nQXaTo5qKg4MXtLz4B21qyV67AKa5ZsegpcgAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "promise-accuracy": {
    "asset": "editorial-review",
    "alt": "机を囲み、根拠資料を一緒に確認する二人の専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAADwAwCdASoYAA4APu1krU2ppaSiMAgBMB2JZQDE2BMXrxsUp08R43YAAP3z2nLNggHlpfupQnj0AeT/Gsw5R5RfnKpuAulHZk/XbLN5oJHD2G97pnyIxjyyi771Z94AGIlnXoCS4sZQW4qZbB3Ryku58IBzkqWMKIFeIAAA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "promise-aim": {
    "asset": "editorial-research",
    "alt": "パソコンと印刷資料を見比べて分析する担当者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAABQBACdASoYAA4APu1mqk2ppaQiMAgBMB2JZQDMV/7AhDr1k7VBbfomphMAAP6xklozoJ/BPfc5meWCQ117G9JcjPhWuQk4+2UaItRzMnEcgh2mjfj2WHxxlN5fpSSuCeRpkF8kdSB6TkQA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "promise-grow": {
    "asset": "editorial-planning",
    "alt": "手帳と資料を広げ、記事の予定と実務の知見を整理する机",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAAAQBACdASoYAA4APu1kqU2ppaQiMAgBMB2JQAAKlARVLZzN9/wtX3RRQAD+jSJH6+t+x1c520hvXlfEiTyy4HX+eDTAw/N062VAAKnQsFwZuNQK7nUgaDyShFIEisznz6gr1KyErJymjCfYt/YAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "renewal": {
    "asset": "editorial-review",
    "alt": "机を囲み、根拠資料を一緒に確認する二人の専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAADwAwCdASoYAA4APu1krU2ppaSiMAgBMB2JZQDE2BMXrxsUp08R43YAAP3z2nLNggHlpfupQnj0AeT/Gsw5R5RfnKpuAulHZk/XbLN5oJHD2G97pnyIxjyyi771Z94AGIlnXoCS4sZQW4qZbB3Ryku58IBzkqWMKIFeIAAA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "trust": {
    "asset": "editorial-planning",
    "alt": "手帳と資料を広げ、記事の予定と実務の知見を整理する机",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAAAQBACdASoYAA4APu1kqU2ppaQiMAgBMB2JQAAKlARVLZzN9/wtX3RRQAD+jSJH6+t+x1c520hvXlfEiTyy4HX+eDTAw/N062VAAKnQsFwZuNQK7nUgaDyShFIEisznz6gr1KyErJymjCfYt/YAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "season-q1": {
    "asset": "editorial-quarter-one",
    "alt": "冬の税理士事務所で確定申告に向けて領収書と資料を整理する手元",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRoQAAABXRUJQVlA4IHgAAAAwBACdASoYAA4APu1kqk4ppaQiMAgBMB2JZwDImBcGpkcbxbcjILeUPRAA/u8fp5OUMac4/pEMH4E7qsT7+gnnJnIzme71TI54T+wbhRqb7t7ketoyC+9jfkdl4ucbkV8cJlAEP3nNRU1tw6FwZWYZ6qhAiJKxgAA=",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "season-q2": {
    "asset": "editorial-quarter-two",
    "alt": "春の明るい窓辺で新年度の資料を準備する担当者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRmgAAABXRUJQVlA4IFwAAACQAgCdASoYAA4AA4BaJQAAYAInfZPOsbRwwn5UgAD+sKF5pM+VKZaDJHlmXy0fB/mQlioh47K46aeZdpofxw1BsrVQstQkyx0jsCHzWYGZDqJm+PaJBQKGlOAAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "season-q3": {
    "asset": "editorial-quarter-three",
    "alt": "夏の緑が見える相談室で専門家と話す家族",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRngAAABXRUJQVlA4IGwAAADwAwCdASoYAA4APu1mqk4ppaOiMAgBMB2JYwC7AB5v8veOAI/RIGdgAM2YWyAPe6GYQ/wG6DHQXIferqRpYhD+so4lvUFF97t4zn95DsrllI0KSbNQCINr+ZLvAEHCaspCWbxGddSTGbameAA=",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "season-q4": {
    "asset": "editorial-quarter-four",
    "alt": "晩秋の光の中で年末調整の資料を確認する手元",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAAAwBACdASoYAA4APu1kqk4ppaQiMAgBMB2JQBOgBH8R3HWrOERbaL7U7+AA/r/+zG+d/aR0kkMEw9loowfs3KKn/vHM4+L6CzEtnMMw/htL4kOx2DVR61FANhi3hTufGG1qVfiP50b4V4HjplPq/7ae4uKQZyZEMABrLQAA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "login-secure": {
    "asset": "editorial-accountant",
    "alt": "窓辺の事務所で資料を丁寧に読み込む専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAADQAwCdASoYAA4APu1yrU+pp6QiMAgBMB2JYwC7ACCq8UOo0qX2TgAA/tpLXceV2d0lkke4m6u01gwoV1YYBdEfpsd1NuHTcYjcXGX8nQXaTo5qKg4MXtLz4B21qyV67AKa5ZsegpcgAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "dashboard-desk": {
    "asset": "editorial-planning",
    "alt": "手帳と資料を広げ、記事の予定と実務の知見を整理する机",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAAAQBACdASoYAA4APu1kqU2ppaQiMAgBMB2JQAAKlARVLZzN9/wtX3RRQAD+jSJH6+t+x1c520hvXlfEiTyy4HX+eDTAw/N062VAAKnQsFwZuNQK7nUgaDyShFIEisznz6gr1KyErJymjCfYt/YAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "keywords": {
    "asset": "editorial-research",
    "alt": "パソコンと印刷資料を見比べて分析する担当者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAABQBACdASoYAA4APu1mqk2ppaQiMAgBMB2JZQDMV/7AhDr1k7VBbfomphMAAP6xklozoJ/BPfc5meWCQ117G9JcjPhWuQk4+2UaItRzMnEcgh2mjfj2WHxxlN5fpSSuCeRpkF8kdSB6TkQA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "articles": {
    "asset": "editorial-accountant",
    "alt": "窓辺の事務所で資料を丁寧に読み込む専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAADQAwCdASoYAA4APu1yrU+pp6QiMAgBMB2JYwC7ACCq8UOo0qX2TgAA/tpLXceV2d0lkke4m6u01gwoV1YYBdEfpsd1NuHTcYjcXGX8nQXaTo5qKg4MXtLz4B21qyV67AKa5ZsegpcgAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "article-detail": {
    "asset": "editorial-review",
    "alt": "机を囲み、根拠資料を一緒に確認する二人の専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAADwAwCdASoYAA4APu1krU2ppaSiMAgBMB2JZQDE2BMXrxsUp08R43YAAP3z2nLNggHlpfupQnj0AeT/Gsw5R5RfnKpuAulHZk/XbLN5oJHD2G97pnyIxjyyi771Z94AGIlnXoCS4sZQW4qZbB3Ryku58IBzkqWMKIFeIAAA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "calendar": {
    "asset": "editorial-research",
    "alt": "パソコンと印刷資料を見比べて分析する担当者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAABQBACdASoYAA4APu1mqk2ppaQiMAgBMB2JZQDMV/7AhDr1k7VBbfomphMAAP6xklozoJ/BPfc5meWCQ117G9JcjPhWuQk4+2UaItRzMnEcgh2mjfj2WHxxlN5fpSSuCeRpkF8kdSB6TkQA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "report": {
    "asset": "editorial-review",
    "alt": "机を囲み、根拠資料を一緒に確認する二人の専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAADwAwCdASoYAA4APu1krU2ppaSiMAgBMB2JZQDE2BMXrxsUp08R43YAAP3z2nLNggHlpfupQnj0AeT/Gsw5R5RfnKpuAulHZk/XbLN5oJHD2G97pnyIxjyyi771Z94AGIlnXoCS4sZQW4qZbB3Ryku58IBzkqWMKIFeIAAA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "review": {
    "asset": "editorial-review",
    "alt": "机を囲み、根拠資料を一緒に確認する二人の専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAADwAwCdASoYAA4APu1krU2ppaSiMAgBMB2JZQDE2BMXrxsUp08R43YAAP3z2nLNggHlpfupQnj0AeT/Gsw5R5RfnKpuAulHZk/XbLN5oJHD2G97pnyIxjyyi771Z94AGIlnXoCS4sZQW4qZbB3Ryku58IBzkqWMKIFeIAAA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "settings": {
    "asset": "editorial-accountant",
    "alt": "窓辺の事務所で資料を丁寧に読み込む専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAADQAwCdASoYAA4APu1yrU+pp6QiMAgBMB2JYwC7ACCq8UOo0qX2TgAA/tpLXceV2d0lkke4m6u01gwoV1YYBdEfpsd1NuHTcYjcXGX8nQXaTo5qKg4MXtLz4B21qyV67AKa5ZsegpcgAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "setup": {
    "asset": "editorial-accountant",
    "alt": "窓辺の事務所で資料を丁寧に読み込む専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAADQAwCdASoYAA4APu1yrU+pp6QiMAgBMB2JYwC7ACCq8UOo0qX2TgAA/tpLXceV2d0lkke4m6u01gwoV1YYBdEfpsd1NuHTcYjcXGX8nQXaTo5qKg4MXtLz4B21qyV67AKa5ZsegpcgAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "notes": {
    "asset": "editorial-planning",
    "alt": "手帳と資料を広げ、記事の予定と実務の知見を整理する机",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAAAQBACdASoYAA4APu1kqU2ppaQiMAgBMB2JQAAKlARVLZzN9/wtX3RRQAD+jSJH6+t+x1c520hvXlfEiTyy4HX+eDTAw/N062VAAKnQsFwZuNQK7nUgaDyShFIEisznz6gr1KyErJymjCfYt/YAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "supervisors": {
    "asset": "editorial-review",
    "alt": "机を囲み、根拠資料を一緒に確認する二人の専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAADwAwCdASoYAA4APu1krU2ppaSiMAgBMB2JZQDE2BMXrxsUp08R43YAAP3z2nLNggHlpfupQnj0AeT/Gsw5R5RfnKpuAulHZk/XbLN5oJHD2G97pnyIxjyyi771Z94AGIlnXoCS4sZQW4qZbB3Ryku58IBzkqWMKIFeIAAA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "wordpress": {
    "asset": "editorial-research",
    "alt": "パソコンと印刷資料を見比べて分析する担当者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAABQBACdASoYAA4APu1mqk2ppaQiMAgBMB2JZQDMV/7AhDr1k7VBbfomphMAAP6xklozoJ/BPfc5meWCQ117G9JcjPhWuQk4+2UaItRzMnEcgh2mjfj2WHxxlN5fpSSuCeRpkF8kdSB6TkQA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "usage": {
    "asset": "editorial-planning",
    "alt": "手帳と資料を広げ、記事の予定と実務の知見を整理する机",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAAAQBACdASoYAA4APu1kqU2ppaQiMAgBMB2JQAAKlARVLZzN9/wtX3RRQAD+jSJH6+t+x1c520hvXlfEiTyy4HX+eDTAw/N062VAAKnQsFwZuNQK7nUgaDyShFIEisznz6gr1KyErJymjCfYt/YAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "admin-offices": {
    "asset": "editorial-research",
    "alt": "パソコンと印刷資料を見比べて分析する担当者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAABQBACdASoYAA4APu1mqk2ppaQiMAgBMB2JZQDMV/7AhDr1k7VBbfomphMAAP6xklozoJ/BPfc5meWCQ117G9JcjPhWuQk4+2UaItRzMnEcgh2mjfj2WHxxlN5fpSSuCeRpkF8kdSB6TkQA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "admin-usage": {
    "asset": "editorial-planning",
    "alt": "手帳と資料を広げ、記事の予定と実務の知見を整理する机",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAAAQBACdASoYAA4APu1kqU2ppaQiMAgBMB2JQAAKlARVLZzN9/wtX3RRQAD+jSJH6+t+x1c520hvXlfEiTyy4HX+eDTAw/N062VAAKnQsFwZuNQK7nUgaDyShFIEisznz6gr1KyErJymjCfYt/YAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "admin-accounts": {
    "asset": "editorial-accountant",
    "alt": "窓辺の事務所で資料を丁寧に読み込む専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAADQAwCdASoYAA4APu1yrU+pp6QiMAgBMB2JYwC7ACCq8UOo0qX2TgAA/tpLXceV2d0lkke4m6u01gwoV1YYBdEfpsd1NuHTcYjcXGX8nQXaTo5qKg4MXtLz4B21qyV67AKa5ZsegpcgAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "account": {
    "asset": "editorial-review",
    "alt": "机を囲み、根拠資料を一緒に確認する二人の専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAADwAwCdASoYAA4APu1krU2ppaSiMAgBMB2JZQDE2BMXrxsUp08R43YAAP3z2nLNggHlpfupQnj0AeT/Gsw5R5RfnKpuAulHZk/XbLN5oJHD2G97pnyIxjyyi771Z94AGIlnXoCS4sZQW4qZbB3Ryku58IBzkqWMKIFeIAAA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "not-found": {
    "asset": "editorial-planning",
    "alt": "手帳と資料を広げ、記事の予定と実務の知見を整理する机",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAAAQBACdASoYAA4APu1kqU2ppaQiMAgBMB2JQAAKlARVLZzN9/wtX3RRQAD+jSJH6+t+x1c520hvXlfEiTyy4HX+eDTAw/N062VAAKnQsFwZuNQK7nUgaDyShFIEisznz6gr1KyErJymjCfYt/YAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "empty-home": {
    "asset": "editorial-research",
    "alt": "パソコンと印刷資料を見比べて分析する担当者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAABQBACdASoYAA4APu1mqk2ppaQiMAgBMB2JZQDMV/7AhDr1k7VBbfomphMAAP6xklozoJ/BPfc5meWCQ117G9JcjPhWuQk4+2UaItRzMnEcgh2mjfj2WHxxlN5fpSSuCeRpkF8kdSB6TkQA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "feature-keywords-discovery": {
    "asset": "editorial-research",
    "alt": "パソコンと印刷資料を見比べて分析する担当者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAABQBACdASoYAA4APu1mqk2ppaQiMAgBMB2JZQDMV/7AhDr1k7VBbfomphMAAP6xklozoJ/BPfc5meWCQ117G9JcjPhWuQk4+2UaItRzMnEcgh2mjfj2WHxxlN5fpSSuCeRpkF8kdSB6TkQA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "feature-outline-board": {
    "asset": "editorial-planning",
    "alt": "手帳と資料を広げ、記事の予定と実務の知見を整理する机",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAAAQBACdASoYAA4APu1kqU2ppaQiMAgBMB2JQAAKlARVLZzN9/wtX3RRQAD+jSJH6+t+x1c520hvXlfEiTyy4HX+eDTAw/N062VAAKnQsFwZuNQK7nUgaDyShFIEisznz6gr1KyErJymjCfYt/YAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "feature-fact-check": {
    "asset": "editorial-accountant",
    "alt": "窓辺の事務所で資料を丁寧に読み込む専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAADQAwCdASoYAA4APu1yrU+pp6QiMAgBMB2JYwC7ACCq8UOo0qX2TgAA/tpLXceV2d0lkke4m6u01gwoV1YYBdEfpsd1NuHTcYjcXGX8nQXaTo5qKg4MXtLz4B21qyV67AKa5ZsegpcgAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "feature-supervision": {
    "asset": "editorial-review",
    "alt": "机を囲み、根拠資料を一緒に確認する二人の専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAADwAwCdASoYAA4APu1krU2ppaSiMAgBMB2JZQDE2BMXrxsUp08R43YAAP3z2nLNggHlpfupQnj0AeT/Gsw5R5RfnKpuAulHZk/XbLN5oJHD2G97pnyIxjyyi771Z94AGIlnXoCS4sZQW4qZbB3Ryku58IBzkqWMKIFeIAAA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "feature-publishing": {
    "asset": "editorial-publishing",
    "alt": "記事の下書きと原稿をデスクトップ画面で確認する編集者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRngAAABXRUJQVlA4IGwAAADQAwCdASoYAA4APu1kqk4ppaQiMAgBMB2JZQDE2BhorvtZbEwb/TAA/pTJ/t+N79Q5yp7KOJNKT0wGAgM0UeaiFXYTe5T62v+rvNsduvxpJhxBN9Tk0PmCfXEzYQVkxa+ZrwYpdWOz/2TAAAA=",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "feature-growth-review": {
    "asset": "editorial-growth",
    "alt": "会議室で推移のグラフを見ながら改善策を話し合う担当者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAAAQBACdASoYAA4APu1kqk4ppaQiMAgBMB2JZwAAQqG4LuD3PJ3YRlc4gAD+7dMuMxc1gbndbnSsP8b6rEoZiTBHciCqOhIvTGg97YVwja1rf3UGeLxjf43bJ3pfeLgA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "feature-tax-calendar": {
    "asset": "editorial-planning",
    "alt": "手帳と資料を広げ、記事の予定と実務の知見を整理する机",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAAAQBACdASoYAA4APu1kqU2ppaQiMAgBMB2JQAAKlARVLZzN9/wtX3RRQAD+jSJH6+t+x1c520hvXlfEiTyy4HX+eDTAw/N062VAAKnQsFwZuNQK7nUgaDyShFIEisznz6gr1KyErJymjCfYt/YAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "feature-knowledge-notes": {
    "asset": "editorial-dictation",
    "alt": "録音機に実務の気づきを話し、知見を記録する専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAABwAwCdASoYAA4APu1kq04ppaQiMAgBMB2JZQAACCSvGwr/+0AA/ut9xs36Hrk3T7hlRtsafY1/3NyZB49ycKttuZBXyPKcd1YMIutHjWjew+kIQ6A8Od8mpq/mQlbvUtmxjjOs4QS720dtqTAAAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "feature-monthly-report": {
    "asset": "editorial-research",
    "alt": "パソコンと印刷資料を見比べて分析する担当者",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAABQBACdASoYAA4APu1mqk2ppaQiMAgBMB2JZQDMV/7AhDr1k7VBbfomphMAAP6xklozoJ/BPfc5meWCQ117G9JcjPhWuQk4+2UaItRzMnEcgh2mjfj2WHxxlN5fpSSuCeRpkF8kdSB6TkQA",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  },
  "feature-secure-onboarding": {
    "asset": "editorial-accountant",
    "alt": "窓辺の事務所で資料を丁寧に読み込む専門家",
    "width": 1672,
    "height": 941,
    "focus": "50% 50%",
    "widths": [
      640,
      1280,
      1672
    ],
    "placeholder": "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAADQAwCdASoYAA4APu1yrU+pp6QiMAgBMB2JYwC7ACCq8UOo0qX2TgAA/tpLXceV2d0lkke4m6u01gwoV1YYBdEfpsd1NuHTcYjcXGX8nQXaTo5qKg4MXtLz4B21qyV67AKa5ZsegpcgAA==",
    "credit": {
      "author": "Expert Column AI（AI による制作）",
      "source": "",
      "license": "AI生成イメージ。実在の社員・顧客や実際の業務画面を撮影したものではありません。",
      "licenseUrl": ""
    }
  }
} as const;
export type PhotoName = keyof typeof PHOTOS;
